<template>
    <div class="withdrawal-container">
        <!-- 搜索区域 -->
        <el-form :inline="true" :model="queryParams" class="demo-form-inline" size="small" style="text-align: left;margin-top: 5px">
            <el-form-item label="提现人昵称">
                <el-input v-model="queryParams.jpNickName" placeholder="请输入昵称查询" clearable></el-input>
            </el-form-item>
            <el-form-item label="手机号">
                <el-input v-model="queryParams.jpPhone" placeholder="请输入手机号查询" clearable></el-input>
            </el-form-item>
            <el-form-item label="审核状态">
                <el-select v-model="queryParams.status" placeholder="请选择状态" clearable>
                    <el-option label="全部" value=""></el-option>
                    <el-option label="审核中" value="0"></el-option>
                    <el-option label="已打款" value="1"></el-option>
                    <el-option label="已拒绝" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="提现时间">
                <el-date-picker
                    v-model="withdrawalTime"
                    type="datetimerange"
                    :picker-options="pickerOptions"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    align="right"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    clearable>
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="mini" @click="getList()">查询</el-button>
                <el-button icon="el-icon-refresh" size="mini" @click="resetQuery()">重置</el-button>
                <el-button
                    type="success"
                    size="mini"
                    icon="el-icon-download"
                    :loading="exportLoading"
                    @click="exportReport">
                    导出报表
                </el-button>
            </el-form-item>
        </el-form>

        <!-- 数据统计卡片 -->
        <el-row :gutter="20" style="margin-bottom: 20px;">
            <el-col :span="6">
                <el-card shadow="hover" class="stat-card stat-card-pending">
                    <div class="stat-content">
                        <div class="stat-icon">
                            <i class="el-icon-time"></i>
                        </div>
                        <div class="stat-info">
                            <div class="stat-label">待审核</div>
                            <div class="stat-value">{{ stats.pending }}</div>
                        </div>
                    </div>
                </el-card>
            </el-col>
            <el-col :span="6">
                <el-card shadow="hover" class="stat-card stat-card-success">
                    <div class="stat-content">
                        <div class="stat-icon">
                            <i class="el-icon-success"></i>
                        </div>
                        <div class="stat-info">
                            <div class="stat-label">已打款</div>
                            <div class="stat-value">{{ stats.success }}</div>
                        </div>
                    </div>
                </el-card>
            </el-col>
            <el-col :span="6">
                <el-card shadow="hover" class="stat-card stat-card-rejected">
                    <div class="stat-content">
                        <div class="stat-icon">
                            <i class="el-icon-close"></i>
                        </div>
                        <div class="stat-info">
                            <div class="stat-label">已拒绝</div>
                            <div class="stat-value">{{ stats.rejected }}</div>
                        </div>
                    </div>
                </el-card>
            </el-col>
            <el-col :span="6">
                <el-card shadow="hover" class="stat-card stat-card-amount">
                    <div class="stat-content">
                        <div class="stat-icon">
                            <i class="el-icon-coin"></i>
                        </div>
                        <div class="stat-info">
                            <div class="stat-label">累计提现金额</div>
                            <div class="stat-value">¥{{ stats.totalAmount }}</div>
                        </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>

        <!-- 表格区域 -->
        <el-table :data="list" style="width: 100%" v-loading="loading">
            <el-table-column type="index" label="序号" width="60" align="center"/>
            <el-table-column label="提现人" prop="jpNickName" width="120"/>
            <el-table-column label="联系方式" width="180">
                <template slot-scope="scope">
                    <div style="margin-bottom: 4px;">
                        <span style="color: #606266;">手机：{{ scope.row.jpPhone }}</span>
                    </div>
                    <div style="color: #909399; font-size: 12px;">
                        <i class="el-icon-chat-dot-round" style="margin-right: 4px;"></i>微信：{{ scope.row.withdrawalWx }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="真实姓名" prop="withdrawalName" min-width="100"/>
            <el-table-column label="提现金额" width="130" align="center">
                <template slot-scope="scope">
                    <div style="color: #00C2A8; font-weight: 600; font-size: 18px; font-family: 'Arial', sans-serif;">
                        ¥{{ scope.row.balance }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="申请时间" prop="createTime" width="180">
                <template slot-scope="scope">
                    <div style="color: #606266;">
                        <i class="el-icon-time" style="margin-right: 4px; color: #909399;"></i>
                        {{ scope.row.createTime | dateFormat }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="审核状态" width="100" align="center">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.status=='0'" type="warning" size="medium">审核中</el-tag>
                    <el-tag v-else-if="scope.row.status=='1'" type="success" size="medium">已打款</el-tag>
                    <el-tag v-else-if="scope.row.status=='2'" type="danger" size="medium">已拒绝</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="转账状态" width="140" align="center">
                <template slot-scope="scope">
                    <div>
                        <!-- 已拒绝时不再显示“已打款/等待确认” -->
                        <template v-if="scope.row.status=='2' || scope.row.transferStatus=='REJECTED'">
                            <el-tag type="danger" size="medium">
                                <i class="el-icon-circle-close"></i> 已拒绝
                            </el-tag>
                        </template>
                        <template v-else>
                            <el-tag v-if="scope.row.transferStatus=='PENDING'" type="info" size="medium">待转账</el-tag>
                            <el-tag v-else-if="scope.row.transferStatus=='PROCESSING'" type="warning" size="medium">
                                <i class="el-icon-loading"></i> 转账中
                            </el-tag>
                            <el-tag v-else-if="scope.row.transferStatus=='SUCCESS'" type="success" size="medium">
                                <i class="el-icon-circle-check"></i> 转账成功
                            </el-tag>
                            <el-tag v-else-if="scope.row.transferStatus=='FAIL'" type="danger" size="medium">
                                <i class="el-icon-circle-close"></i> 转账失败
                            </el-tag>
                            <span v-else style="color: #c0c4cc;">-</span>
                            
                            <!-- 用户确认状态（已拒绝不展示） -->
                            <div v-if="scope.row.userConfirmStatus && scope.row.userConfirmStatus !== 'CANCELLED'" style="margin-top: 4px; font-size: 12px;">
                                <el-tag v-if="scope.row.userConfirmStatus=='WAIT_CONFIRM'" type="warning" size="mini">
                                    等待确认
                                </el-tag>
                                <el-tag v-else-if="scope.row.userConfirmStatus=='CONFIRMED'" type="success" size="mini">
                                    已确认
                                </el-tag>
                                <el-tag v-else-if="scope.row.userConfirmStatus=='EXPIRED'" type="info" size="mini">
                                    已过期
                                </el-tag>
                            </div>
                        </template>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="更新时间" prop="updateTime" width="180">
                <template slot-scope="scope">
                    <div v-if="scope.row.updateTime" style="color: #606266;">
                        <i class="el-icon-refresh" style="margin-right: 4px; color: #909399;"></i>
                        {{ scope.row.updateTime | dateFormat }}
                    </div>
                    <span v-else style="color: #c0c4cc;">暂无</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="250">
                <template slot-scope="scope">
                    <div v-if="scope.row.status=='0'" style="display: flex; gap: 8px; justify-content: center; flex-wrap: wrap;">
                        <el-button 
                            @click="handleConfirm(scope.row, '1')" 
                            type="success" 
                            size="mini" 
                            plain
                            style="border-radius: 4px;">
                            <i class="el-icon-circle-check"></i> 微信转账
                        </el-button>
                        <el-button 
                            @click="handleConfirm(scope.row, '2')" 
                            type="danger" 
                            size="mini" 
                            plain
                            style="border-radius: 4px;">
                            <i class="el-icon-circle-close"></i> 拒绝
                        </el-button>
                        <el-button 
                            v-if="scope.row.transferStatus && scope.row.outBatchNo"
                            @click="showTransferDetail(scope.row)" 
                            type="primary" 
                            size="mini" 
                            plain
                            style="border-radius: 4px;">
                            <i class="el-icon-view"></i> 查看详情
                        </el-button>
                    </div>
                    <div v-else style="display: flex; gap: 8px; justify-content: center;">
                        <el-tag type="info" size="small">已处理</el-tag>
                        <el-button 
                            v-if="scope.row.transferStatus && scope.row.outBatchNo"
                            @click="showTransferDetail(scope.row)" 
                            type="text" 
                            size="mini">
                            <i class="el-icon-view"></i> 查看转账详情
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <template v-if="list.length!=0">
            <el-pagination 
                @size-change="handleSizeChange" 
                @current-change="handleCurrentChange" 
                :current-page="queryParams.pageNum" 
                :page-sizes="[10, 20, 50, 100]"
                :page-size="queryParams.pageSize" 
                layout="total, sizes, prev, pager, next, jumper" 
                :total="total">
            </el-pagination>
        </template>
    </div>
</template>

<script>
import { downloadReport } from '@/assets/js/reportDownload'

export default {
    name: 'WithdrawalCenter',
    data() {
        return {
            loading: false,
            exportLoading: false,
            list: [],
            total: 0,
            queryParams: {
                pageNum: 1,
                pageSize: 10,
                jpNickName: '',
                jpPhone: '',
                status: '',
                beginTime: '',
                endTime: ''
            },
            withdrawalTime: [],
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            stats: {
                pending: 0,
                success: 0,
                rejected: 0,
                totalAmount: '0.00'
            }
        }
    },
    mounted() {
        this.getList();
    },
    methods: {
        async getList() {
            this.loading = true;
            try {
                // 处理时间范围参数
                if (this.withdrawalTime && this.withdrawalTime.length === 2) {
                    this.queryParams.beginTime = this.withdrawalTime[0];
                    this.queryParams.endTime = this.withdrawalTime[1];
                } else {
                    this.queryParams.beginTime = '';
                    this.queryParams.endTime = '';
                }
                const { data: res } = await this.$http.get('/balance/getCampusWithDrawlList', {
                    params: this.queryParams
                });
                if (res.code === 200) {
                    this.list = res.data.children || [];
                    this.total = res.data.total || 0;
                    this.calculateStats();
                } else {
                    this.$message.error(res.msg || '获取数据失败');
                }
            } catch (error) {
                console.error('获取提现列表失败:', error);
                this.$message.error('获取数据失败，请稍后重试');
            } finally {
                this.loading = false;
            }
        },
        
        async exportReport() {
            this.exportLoading = true;
            try {
                const params = { ...this.queryParams };
                delete params.pageNum;
                delete params.pageSize;
                // 处理时间范围
                if (this.withdrawalTime && this.withdrawalTime.length === 2) {
                    params.beginTime = this.withdrawalTime[0];
                    params.endTime = this.withdrawalTime[1];
                } else {
                    params.beginTime = '';
                    params.endTime = '';
                }
                await downloadReport(
                    this.$http,
                    '/admin/report/export/withdrawals',
                    params,
                    '提现记录报表.xlsx'
                );
                this.$message.success('提现记录报表导出成功');
            } catch (error) {
                this.$message.error(error.message || '提现记录报表导出失败');
            } finally {
                this.exportLoading = false;
            }
        },
        
        calculateStats() {
            // 重置统计数据
            this.stats.pending = 0;
            this.stats.success = 0;
            this.stats.rejected = 0;
            let totalAmount = 0;
            
            // 需要获取所有数据来统计，这里先用当前页数据
            this.list.forEach(item => {
                if (item.status == '0') {
                    this.stats.pending++;
                } else if (item.status == '1') {
                    this.stats.success++;
                    totalAmount += parseFloat(item.balance || 0);
                } else if (item.status == '2') {
                    this.stats.rejected++;
                }
            });
            
            this.stats.totalAmount = totalAmount.toFixed(2);
        },
        
        handleConfirm(row, status) {
            const statusText = status === '1' ? '微信转账' : '拒绝提现';
            let confirmText = '';
            
            if (status === '1') {
                confirmText = `
                    <div style="text-align: left; line-height: 1.8;">
                        <p style="margin: 10px 0;"><strong>确认向以下用户发起微信转账？</strong></p>
                        <p style="margin: 5px 0;">收款人：${row.withdrawalName || row.jpNickName}</p>
                        <p style="margin: 5px 0;">提现金额：<span style="color: #00C2A8; font-weight: bold; font-size: 16px;">¥${row.balance}</span></p>
                        <p style="margin: 5px 0;">联系方式：${row.jpPhone}</p>
                        <p style="margin: 15px 0; padding: 10px; background: #fff3cd; border-radius: 4px; color: #856404;">
                            <i class="el-icon-warning"></i> 转账将通过微信商家转账API自动发起，请确认信息无误
                        </p>
                        <p style="margin: 15px 0; padding: 10px; background: #e6f7ff; border-radius: 4px; color: #0050b3;">
                            <i class="el-icon-info"></i> <strong>新版转账流程</strong>：用户需要在微信中确认收款，24小时内未确认将自动退回
                        </p>
                    </div>
                `;
            } else {
                confirmText = `确认拒绝 ${row.withdrawalName || row.jpNickName} 的提现申请吗？`;
            }
            
            this.$confirm(confirmText, status === '1' ? '微信转账确认' : '拒绝提现', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                dangerouslyUseHTMLString: true,
                customClass: 'transfer-confirm-dialog'
            }).then(async () => {
                // 显示加载提示
                const loading = this.$loading({
                    lock: true,
                    text: status === '1' ? '正在发起微信转账，请稍候...' : '正在处理...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                
                try {
                    const { data: res } = await this.$http.post('/balance/confirmWithdrawal', {
                        id: row.id,
                        status: status,
                        userId: row.userId
                    });
                    
                    loading.close();
                    
                    if (res.code === 200) {
                        if (status === '1') {
                            // 检查是否有packageInfo，用于调起微信确认收款页面
                            if (res.data && res.data.packageInfo) {
                                this.$message({
                                    type: 'success',
                                    message: '转账已发起成功！',
                                    duration: 3000
                                });
                                
                                // 显示确认收款链接对话框
                                this.showConfirmLinkDialog(res.data, row);
                            } else {
                                this.$message({
                                    type: 'success',
                                    message: res.msg || '转账已发起，请通知用户在微信中确认收款（24小时内有效）',
                                    duration: 6000,
                                    showClose: true
                                });
                                
                                // 显示详细提示
                                this.$notify({
                                    title: '转账已发起',
                                    message: '用户需要在微信客户端确认收款。请通过微信或短信通知用户及时确认，24小时内未确认将自动退回。',
                                    type: 'info',
                                    duration: 10000,
                                    position: 'bottom-right'
                                });
                            }
                        } else {
                            this.$message.success('操作成功');
                        }
                        this.getList();
                    } else {
                        this.$message.error(res.msg || statusText + '失败');
                    }
                } catch (error) {
                    loading.close();
                    console.error('操作失败:', error);
                    let errorMsg = '操作失败，请稍后重试';
                    if (error.response && error.response.data && error.response.data.msg) {
                        errorMsg = error.response.data.msg;
                    }
                    this.$message.error(errorMsg);
                }
            }).catch(() => {
                this.$message.info('已取消操作');
            });
        },
        
        /**
         * 调起微信确认收款页面
         * @param {String} packageInfo - 从后端获取的package_info
         * @param {Object} row - 提现记录信息
         */
        openWechatConfirmPage(packageInfo, row) {
            // 检查是否在微信环境中
            const isWechat = /MicroMessenger/i.test(navigator.userAgent);
            
            if (!isWechat) {
                // 不在微信环境中，显示提示信息
                                this.$alert(
                    `<div style="text-align: left; line-height: 1.8;">
                        <p><strong>转账已发起成功！</strong></p>
                        <p>收款人：${row.withdrawalName || row.jpNickName}</p>
                        <p>转账金额：<span style="color: #00C2A8; font-weight: bold;">¥${row.balance}</span></p>
                        <p style="margin-top: 15px; padding: 10px; background: #fff3cd; border-radius: 4px; color: #856404;">
                            <i class="el-icon-warning"></i> <strong>重要提示：</strong>
                        </p>
                        <p style="margin: 10px 0;"><strong>用户确认收款步骤：</strong></p>
                        <p style="margin: 5px 0; padding-left: 20px;">1. 打开微信APP</p>
                        <p style="margin: 5px 0; padding-left: 20px;">2. 在聊天列表顶部找到 <strong>"服务通知"</strong>（或搜索"微信支付"）</p>
                        <p style="margin: 5px 0; padding-left: 20px;">3. 点击进入，找到转账消息（标题：您有一笔转账待确认）</p>
                        <p style="margin: 5px 0; padding-left: 20px;">4. 点击转账消息，进入详情页面</p>
                        <p style="margin: 5px 0; padding-left: 20px;">5. 点击 <strong>"确认收款"</strong> 按钮</p>
                        <p style="margin-top: 10px; padding: 10px; background: #f56c6c; border-radius: 4px; color: #fff;">
                            <i class="el-icon-time"></i> <strong>必须在24小时内确认，否则将自动退回！</strong>
                        </p>
                        <p style="margin-top: 10px; padding: 10px; background: #e6f7ff; border-radius: 4px; color: #0050b3;">
                            <i class="el-icon-info"></i> <strong>通知用户：</strong>可以通过微信或短信告知用户："您有一笔¥${row.balance}的转账待确认，请在微信服务通知中查看并确认收款"
                        </p>
                    </div>`,
                    '转账已发起 - 请通知用户确认收款',
                    {
                        confirmButtonText: '我知道了',
                        dangerouslyUseHTMLString: true,
                        type: 'success',
                        width: '600px'
                    }
                );
                return;
            }
            
            // 在微信环境中，尝试调起确认收款页面
            try {
                // 检查是否支持 wx.requestMerchantTransfer API
                if (typeof wx !== 'undefined' && wx.requestMerchantTransfer) {
                    // 微信小程序环境
                    wx.requestMerchantTransfer({
                        package: packageInfo,
                        success: (res) => {
                            console.log('调起微信确认收款页面成功', res);
                            this.$message({
                                type: 'success',
                                message: '已调起微信确认收款页面，请用户在微信中确认收款',
                                duration: 5000
                            });
                        },
                        fail: (err) => {
                            console.error('调起微信确认收款页面失败', err);
                            this.showPackageInfoDialog(packageInfo, row);
                        }
                    });
                } else if (typeof WeixinJSBridge !== 'undefined') {
                    // 微信H5环境（需要根据实际API调整）
                    this.showPackageInfoDialog(packageInfo, row);
                } else {
                    // 其他情况，显示packageInfo供用户手动操作
                    this.showPackageInfoDialog(packageInfo, row);
                }
            } catch (error) {
                console.error('调起微信确认收款页面异常', error);
                this.showPackageInfoDialog(packageInfo, row);
            }
        },
        
        /**
         * 显示确认收款链接对话框
         */
        showConfirmLinkDialog(data, row) {
            // 生成确认收款链接（小程序路径）
            // 注意：在小程序中，直接使用路径即可，不需要完整URL
            // 如果需要在外部（如短信、微信消息）发送，可以使用小程序码或短链接
            const confirmUrl = `/pagesD/tixian/confirmTransfer?id=${row.id}&amount=${row.balance}&remark=${encodeURIComponent(row.remark || '校园兼职提现')}`;
            // 小程序路径（用于在小程序中直接跳转）
            const miniProgramPath = confirmUrl;
            // 如果需要生成外部链接，可以使用小程序码或短链接服务
            const fullUrl = `小程序路径：${miniProgramPath}\n\n提示：请在小程序中打开此路径，或生成小程序码发送给用户`;
            
            this.$alert(
                `<div style="text-align: left; line-height: 1.8;">
                    <p><strong>转账已发起成功！</strong></p>
                    <p>收款人：${row.withdrawalName || row.jpNickName}</p>
                    <p>转账金额：<span style="color: #00C2A8; font-weight: bold;">¥${row.balance}</span></p>
                    <p style="margin-top: 15px; padding: 10px; background: #e6f7ff; border-radius: 4px; color: #0050b3;">
                        <i class="el-icon-info"></i> <strong>请将以下链接发送给用户：</strong>
                    </p>
                    <div style="margin: 10px 0; padding: 12px; background: #f5f7fa; border-radius: 4px; word-break: break-all; font-size: 12px; position: relative;">
                        <span id="confirmLinkText">${miniProgramPath}</span>
                        <el-button 
                            type="text" 
                            size="mini" 
                            style="position: absolute; right: 8px; top: 8px;"
                            @click="copyConfirmLink('${miniProgramPath}')"
                        >复制</el-button>
                    </div>
                    <p style="margin-top: 15px; padding: 10px; background: #fff3cd; border-radius: 4px; color: #856404;">
                        <i class="el-icon-warning"></i> <strong>操作步骤：</strong>
                    </p>
                    <p style="margin: 5px 0; padding-left: 20px;"><strong>方式一：在小程序中跳转（推荐）</strong></p>
                    <p style="margin: 5px 0; padding-left: 20px;">1. 复制上面的小程序路径</p>
                    <p style="margin: 5px 0; padding-left: 20px;">2. 在用户端小程序代码中使用：</p>
                    <p style="margin: 5px 0; padding-left: 40px; font-family: monospace; font-size: 11px; background: #f0f0f0; padding: 8px; border-radius: 4px;">uni.navigateTo({ url: '${miniProgramPath}' })</p>
                    <p style="margin: 10px 0; padding-left: 20px;"><strong>方式二：生成小程序码</strong></p>
                    <p style="margin: 5px 0; padding-left: 20px;">1. 使用微信小程序后台生成小程序码</p>
                    <p style="margin: 5px 0; padding-left: 20px;">2. 路径填写：${miniProgramPath}</p>
                    <p style="margin: 5px 0; padding-left: 20px;">3. 将小程序码发送给用户扫码</p>
                    <p style="margin: 5px 0; padding-left: 20px;">4. 用户扫码后打开小程序确认收款页面</p>
                    <p style="margin-top: 15px; padding: 10px; background: #f56c6c; border-radius: 4px; color: #fff;">
                        <i class="el-icon-time"></i> <strong>重要：用户必须在24小时内确认，否则将自动退回！</strong>
                    </p>
                </div>`,
                '转账已发起 - 请发送确认链接给用户',
                {
                    confirmButtonText: '我知道了',
                    dangerouslyUseHTMLString: true,
                    type: 'success',
                    customClass: 'confirm-link-dialog',
                    width: '700px'
                }
            );
        },
        
        /**
         * 复制确认链接
         */
        copyConfirmLink(url) {
            // 创建临时文本区域
            const textarea = document.createElement('textarea');
            textarea.value = url;
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.select();
            
            try {
                document.execCommand('copy');
                this.$message.success('链接已复制到剪贴板');
            } catch (err) {
                this.$message.error('复制失败，请手动复制');
            } finally {
                document.body.removeChild(textarea);
            }
        },
        
        /**
         * 显示packageInfo对话框（备用方案）
         */
        showPackageInfoDialog(packageInfo, row) {
            this.$alert(
                `<div style="text-align: left; line-height: 1.8;">
                    <p><strong>转账已发起成功！</strong></p>
                    <p>收款人：${row.withdrawalName || row.jpNickName}</p>
                    <p>转账金额：<span style="color: #00C2A8; font-weight: bold;">¥${row.balance}</span></p>
                    <p style="margin-top: 15px; padding: 10px; background: #fff3cd; border-radius: 4px; color: #856404;">
                        <i class="el-icon-warning"></i> <strong>请通知用户确认收款：</strong>
                    </p>
                    <p style="margin: 10px 0;"><strong>方式一：通过微信服务通知（推荐）</strong></p>
                    <p style="margin: 5px 0; padding-left: 20px;">1. 打开微信APP</p>
                    <p style="margin: 5px 0; padding-left: 20px;">2. 在聊天列表顶部找到 <strong>"服务通知"</strong> 或 <strong>"微信支付"</strong></p>
                    <p style="margin: 5px 0; padding-left: 20px;">3. 点击进入，找到转账消息（标题：您有一笔转账待确认）</p>
                    <p style="margin: 5px 0; padding-left: 20px;">4. 点击转账消息，进入详情页面</p>
                    <p style="margin: 5px 0; padding-left: 20px;">5. 点击 <strong>"确认收款"</strong> 按钮</p>
                    <p style="margin: 10px 0;"><strong>方式二：通过"我"页面</strong></p>
                    <p style="margin: 5px 0; padding-left: 20px;">1. 打开微信APP → 点击右下角 <strong>"我"</strong></p>
                    <p style="margin: 5px 0; padding-left: 20px;">2. 点击 <strong>"服务"</strong> 或 <strong>"支付"</strong></p>
                    <p style="margin: 5px 0; padding-left: 20px;">3. 找到 <strong>"服务通知"</strong> 或 <strong>"转账消息"</strong></p>
                    <p style="margin: 5px 0; padding-left: 20px;">4. 查看转账消息并确认收款</p>
                    <p style="margin-top: 15px; padding: 10px; background: #f56c6c; border-radius: 4px; color: #fff;">
                        <i class="el-icon-time"></i> <strong>重要：必须在24小时内确认，否则将自动退回！</strong>
                    </p>
                    <p style="margin-top: 10px; padding: 10px; background: #e6f7ff; border-radius: 4px; color: #0050b3;">
                        <i class="el-icon-info"></i> <strong>提示：</strong>如果用户找不到服务通知，可以搜索"微信支付"或"转账"关键词
                    </p>
                </div>`,
                '转账已发起 - 请通知用户确认收款',
                {
                    confirmButtonText: '我知道了',
                    dangerouslyUseHTMLString: true,
                    type: 'success',
                    customClass: 'package-info-dialog',
                    width: '600px'
                }
            );
        },
        
        showTransferDetail(row) {
            // 构建详情HTML
            let detailHtml = `
                <div style="text-align: left; line-height: 2;">
                    <h3 style="margin: 0 0 15px 0; color: #303133;">微信转账详情</h3>
                    <p><strong>收款人：</strong>${row.withdrawalName || row.jpNickName}</p>
                    <p><strong>转账金额：</strong><span style="color: #00C2A8; font-weight: bold;">¥${row.balance}</span></p>
            `;
            
            if (row.outBatchNo) {
                detailHtml += `<p><strong>商户批次号：</strong><code style="background: #f5f7fa; padding: 2px 8px; border-radius: 3px;">${row.outBatchNo}</code></p>`;
            }
            
            if (row.outDetailNo) {
                detailHtml += `<p><strong>商户明细号：</strong><code style="background: #f5f7fa; padding: 2px 8px; border-radius: 3px;">${row.outDetailNo}</code></p>`;
            }
            
            if (row.wxBatchId) {
                detailHtml += `<p><strong>微信批次号：</strong><code style="background: #f5f7fa; padding: 2px 8px; border-radius: 3px;">${row.wxBatchId}</code></p>`;
            }
            
            if (row.wxDetailId) {
                detailHtml += `<p><strong>微信明细号：</strong><code style="background: #f5f7fa; padding: 2px 8px; border-radius: 3px;">${row.wxDetailId}</code></p>`;
            }
            
            if (row.transferTime) {
                detailHtml += `<p><strong>转账发起时间：</strong>${this.$options.filters.dateFormat(row.transferTime)}</p>`;
            }
            
            if (row.transferSuccessTime) {
                detailHtml += `<p><strong>转账成功时间：</strong>${this.$options.filters.dateFormat(row.transferSuccessTime)}</p>`;
            }
            
            if (row.failReason) {
                detailHtml += `<p style="color: #f56c6c;"><strong>失败原因：</strong>${row.failReason}</p>`;
            }
            
            if (row.remark) {
                detailHtml += `<p><strong>备注：</strong>${row.remark}</p>`;
            }
            
            detailHtml += `</div>`;
            
            this.$alert(detailHtml, '转账详情', {
                confirmButtonText: '关闭',
                dangerouslyUseHTMLString: true,
                customClass: 'transfer-detail-dialog'
            });
        },
        
        resetQuery() {
            this.queryParams = {
                pageNum: 1,
                pageSize: 10,
                jpNickName: '',
                jpPhone: '',
                status: '',
                beginTime: '',
                endTime: ''
            };
            this.withdrawalTime = [];
            this.getList();
        },
        
        handleSizeChange(val) {
            this.queryParams.pageSize = val;
            this.getList();
        },
        
        handleCurrentChange(val) {
            this.queryParams.pageNum = val;
            this.getList();
        }
    }
}
</script>

<style scoped>
.withdrawal-container {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: calc(100vh - 80px);
}

/* 搜索表单样式优化 */
.demo-form-inline {
    background: white;
    padding: 20px;
    border-radius: 8px;
    margin-bottom: 20px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

/* 统计卡片样式 */
.stat-card {
    border-radius: 12px;
    transition: all 0.3s ease;
    border: none;
}

.stat-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.12);
}

.stat-content {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 10px;
}

.stat-icon {
    width: 60px;
    height: 60px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    flex-shrink: 0;
}

.stat-card-pending .stat-icon {
    background: linear-gradient(135deg, rgba(250, 173, 20, 0.15), rgba(250, 173, 20, 0.25));
    color: #faad14;
}

.stat-card-success .stat-icon {
    background: linear-gradient(135deg, rgba(0, 194, 168, 0.15), rgba(0, 194, 168, 0.25));
    color: #00C2A8;
}

.stat-card-rejected .stat-icon {
    background: linear-gradient(135deg, rgba(245, 34, 45, 0.15), rgba(245, 34, 45, 0.25));
    color: #f5222d;
}

.stat-card-amount .stat-icon {
    background: linear-gradient(135deg, rgba(24, 144, 255, 0.15), rgba(24, 144, 255, 0.25));
    color: #1890ff;
}

.stat-info {
    flex: 1;
}

.stat-label {
    font-size: 14px;
    color: #909399;
    margin-bottom: 8px;
}

.stat-value {
    font-size: 26px;
    font-weight: 600;
    color: #303133;
    line-height: 1;
}

/* 表格容器样式 */
::v-deep .el-table {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

/* 表头样式优化 */
::v-deep .el-table th {
    background-color: #fafafa;
    color: #303133;
    font-weight: 600;
    font-size: 14px;
}

::v-deep .el-table th.el-table__cell {
    background-color: #fafafa;
}

/* 表格行样式 */
::v-deep .el-table td {
    padding: 16px 0;
}

::v-deep .el-table tr {
    transition: all 0.2s ease;
}

::v-deep .el-table tbody tr:hover > td {
    background-color: #f5f7fa !important;
}

/* 表格边框 */
::v-deep .el-table--border::after, 
::v-deep .el-table--group::after {
    width: 0;
}

/* 分页样式优化 */
::v-deep .el-pagination {
    margin-top: 20px;
    text-align: right;
    padding: 20px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #00C2A8;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #00C2A8;
}

/* 按钮样式优化 */
::v-deep .el-button--primary {
    background-color: #00C2A8;
    border-color: #00C2A8;
}

::v-deep .el-button--primary:hover {
    background-color: #00d4b8;
    border-color: #00d4b8;
}

/* 标签样式优化 */
::v-deep .el-tag {
    border-radius: 4px;
    padding: 0 12px;
    height: 28px;
    line-height: 28px;
    font-size: 13px;
}

::v-deep .el-tag--warning {
    background-color: #fff7e6;
    border-color: #ffe58f;
    color: #faad14;
}

::v-deep .el-tag--success {
    background-color: #e6fffb;
    border-color: #87e8de;
    color: #00C2A8;
}

::v-deep .el-tag--danger {
    background-color: #fff1f0;
    border-color: #ffccc7;
    color: #f5222d;
}

/* 空数据提示 */
::v-deep .el-table__empty-block {
    padding: 60px 0;
}

::v-deep .el-table__empty-text {
    color: #909399;
}

/* 操作按钮样式优化 */
::v-deep .el-button--success.is-plain {
    color: #00C2A8;
    background: #e6fffb;
    border-color: #87e8de;
}

::v-deep .el-button--success.is-plain:hover {
    background: #00C2A8;
    border-color: #00C2A8;
    color: #fff;
}

::v-deep .el-button--danger.is-plain {
    color: #f5222d;
    background: #fff1f0;
    border-color: #ffccc7;
}

::v-deep .el-button--danger.is-plain:hover {
    background: #f5222d;
    border-color: #f5222d;
    color: #fff;
}

::v-deep .el-button--mini {
    padding: 7px 12px;
    font-size: 12px;
}

/* 表格内按钮容器 */
::v-deep .el-table td .cell {
    padding: 0 10px;
}

/* 转账确认对话框样式 */
::v-deep .transfer-confirm-dialog {
    width: 500px;
}

::v-deep .transfer-confirm-dialog .el-message-box__message {
    font-size: 14px;
}

::v-deep .transfer-confirm-dialog code {
    font-family: 'Courier New', monospace;
    font-size: 12px;
}

/* 转账详情对话框样式 */
::v-deep .transfer-detail-dialog {
    width: 600px;
}

::v-deep .transfer-detail-dialog .el-message-box__message {
    max-height: 500px;
    overflow-y: auto;
}

::v-deep .transfer-detail-dialog code {
    font-family: 'Courier New', monospace;
    font-size: 13px;
    color: var(--primary-color);
}

::v-deep .transfer-detail-dialog h3 {
    border-bottom: 2px solid #00C2A8;
    padding-bottom: 10px;
}
</style>

